<template lang="pug">
section.subpage.billings.pb-5(ref="subpage")
  template(v-if="currentUser && currentUser.acl && currentUser.acl.billings && currentUser.acl.billings.get && (currentUser.role === 'admin' || currentUser.role === 'master')")
    h2.title
      span {{ page.title }}
    b-table(ref="table",responsive,no-local-sorting,:items="data",:fields="fields")
      template(v-slot:cell(targetMonth)="row")
        span {{ formatYearMonth(row.item.targetMonth) }}
      template(v-slot:cell(licenseVolume)="row")
        b-row
          b-col.text-left
            span {{ row.item.licenseVolume ? Number(row.item.licenseVolume).toLocaleString('ja-JP') : 0 }}アカウント
          b-col.text-right.pr-3
            b-button.p-0(variant="link",v-if="row.item.isBilling",@click="download(`/mycompany/billings/${row.item._id}/files/billing.pdf`, `billing_${row.item.targetMonth}`)") 請求書
            span.separator.mx-2(v-if="row.item.isBilling && row.item.isReceipt") |
            b-button.p-0(variant="link",v-if="row.item.isReceipt",@click="download(`/mycompany/billings/${row.item._id}/files/receipt.pdf`, `receipt_${row.item.targetMonth}`)") 領収書
      template(v-slot:cell(totalPrice)="row")
        span {{ row.item.totalPrice ? Number(row.item.totalPrice).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' }) : Number(0).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' }) }}

    .d-flex.justify-content-center
      b-pagination.mt-3(v-model="currentPage",:value="currentPage",:per-page="perPage",:total-rows="allCount")

  template(v-else)
    .text-center.my-5.py-5.text-danger 設定されている権限では本機能はご利用できません
</template>

<script>
import QueryHash from 'query-hash'

import { getData } from '../utils/api'

import { clone } from '../utils/libs'

const page = {
  id: 'billings',
  title: '請求書・領収書'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      page: page,
      currentUser: null,
      currentPage: 1,
      perPage: 10,
      allCount: 0,
      data: [],
      fields: [
        {
          key: 'targetMonth',
          label: '年月'
        },
        {
          key: 'licenseVolume',
          label: 'メンバーアカウント数'
        },
        {
          key: 'totalPrice',
          label: '金額'
        }
      ]
    }
  },
  watch: {
    currentPage (newVal, oldVal) {
      if (oldVal && newVal && oldVal !== newVal) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    formatYearMonth (ym) {
      if (ym.match(/^([0-9]{4})([0-9]{2})$/)) {
        return `${RegExp.$1}年${RegExp.$2}月`
      } else {
        return '-'
      }
    },
    async loadData () {
      this.mask = true

      let query = new QueryHash()

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      await getData(`/mycompany/billings/count`).then((count) => {
        this.allCount = count
      })

      const offset = (this.currentPage - 1) * this.perPage
      const order = '-targetMonth'

      query.add('sort', order)
      query.add('limit', this.perPage)
      if (offset !== 0) {
        query.add('skip', offset)
      }

      this.data = []

      await getData(`/mycompany/billings?${query.toQueryString()}`).then((data) => {
        if (data && data.length > 0) {
          this.data = clone(data)
        }
      }).catch((err) => {
        console.log(err)
      })

      this.$parent.$refs.header.checkCondition()

      this.mask = false
    }
  }
}
</script>

<style scoped lang="stylus">
.table-responsive >>> .b-table
  min-height auto
</style>
